import { Helmet } from "react-helmet-async";
// @mui
import { Container } from "@mui/material";
import Audit from "src/components/Audit/Audit";

// ----------------------------------------------------------------------

export default function CSOAudit() {
  return (
    <>
      <Helmet>
        <title> Clients </title>
      </Helmet>

      <Container maxWidth="xl">
        <Audit />
      </Container>
    </>
  );
}
